import { createFileRoute } from "@tanstack/react-router";
import ContactsImportPage from "@/site/pages/contacts-import";

/**
 * Chrome-less CloudSponge importer for the mobile app's WebView (PRD 02 §5.8). Opened
 * as `/contacts/import?embed=1`; `__root` strips the site chrome for any embedded
 * surface and this path is in `publicPaths` (auth rides the injected app token).
 */
export const Route = createFileRoute("/contacts/import")({
  component: ContactsImportPage,
});
